

define(['squid/index', 'text!./template.html', 'xo-ui-components/src/accessibility/directive'], function (squid, template) {
    squid.module('xo-cart.item-details.directive', ['squid', 'xo-accessibility.directive']).directive('itemDetails', function () {
        return {
            template: template,
            restrict: 'E',
            scope: {
                details: '=',
                sku: '=',
                currencyCode: '=',
                onClickLess: '&'
            },
            controller: function controller() {/* dumb component */}
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/cart/itemDetails/directive.js
// module id = ./components/xo-page-components/src/cart/itemDetails/directive.js
// module chunks = 1